export default __webpack_public_path__ + "static/media/2.287846fc.jpg";